import {
  mdiCommentTextMultiple,
  mdiFileTreeOutline,
  mdiHomeOutline,
  mdiMessageTextOutline,
  mdiSwapVertical,
} from '@mdi/js'
import access from './access'
import accounting from './accounting'
import analyze from './analyze'
import api from './api'
import financial from './financial'
import logs from './logs'
import marketing from './marketing'
import products from './products'
import reports from './reports'
import setting from './setting'
import users from './users'
import application from './application'

export default [
  {
    title: 'داشبورد',
    icon: mdiHomeOutline,
    to: 'home',
    action: 'can_see_dashboard',
    resource: 'all',
  },
  {
    title: 'دسته بندی ها',
    icon: mdiFileTreeOutline,
    to: 'newCategories',
    action: 'can_see_categories',
  },
  {
    title: 'تیکت ها',
    icon: mdiMessageTextOutline,
    to: 'tickets',
    action: 'can_see_tickets',
  },
  {
    title: 'نظرات',
    icon: mdiCommentTextMultiple,
    to: 'comments',
    action: 'can_see_and_edit_comments',
  },
  ...application,
  ...products,
  ...setting,
  ...access,
  ...users,
  ...api,
  ...financial,
  ...accounting,
  ...logs,
  ...marketing,
  ...reports,
  ...analyze,
  {
    title: 'آخرین بروزرسانی ها',
    icon: mdiSwapVertical,
    to: 'last_version',
  },
]
